import {
  INITIATIVE_SET_PATH_REQUEST,
  INITIATIVE_SET_INITIATIVE_CLICKED,
  INITIATIVE_SET_SHOW_PURPOSE
} from '../types';
import axios from 'axios';
import {apiUrl} from '../config/index';
import Swal from 'sweetalert2';
import {queryIsLoading, queryNotLoading} from './globalActions';

export function requestRegionInitiative(data, cbFunction=null) {
  return (dispatch) => {
    dispatch(queryIsLoading());
    axios.get(`${apiUrl}/initiative/`, data).then(result => {
      if(result.status === 200){
        cbFunction(result);
      }
      dispatch(queryNotLoading());
    }).catch(error => {
      dispatch(queryNotLoading());
      console.log(error);
      Swal.fire({
        title:"Error",
        confirmButtonColor:"#0f8238b8",
        text:"Hubo un error, vuelve a intentarlo, Si el error persiste contacte al administrador.",
        type:"error",
        heightAuto:false
      });
    })
  }
}

export function sendVoteInitiative(data, cbFunction) {
  console.log(data);
  return (dispatch) => {
    dispatch(queryIsLoading());
    axios.post(`${apiUrl}/voting/generateVoting/`, data,
    {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
       
      }}).then(result => {
      if(result.status === 200){
        if(result.data.ok === true){
          let icon = "";

          if(result.data.voting === 9){
            icon = "error";
            cbFunction("error");
          }else if(result.data.voting === 8){
            icon = "warning";
            cbFunction("success");
          }else if(result.data.voting === -1){
            icon = "error";
            cbFunction("error");
          }else if(result.data.voting < 8){
            icon = "success";
            cbFunction("success");
          }
          
          Swal.fire({
            title:"Ok",
            confirmButtonColor:"#0f8238b8",
            text:`${result.data.message}`,
            type:icon,
            heightAuto:false
          });
        }
      }
      dispatch(queryNotLoading());
    }).catch(error => {
      dispatch(queryNotLoading());
      console.log(error);
      Swal.fire({
          title:"Error",
          confirmButtonColor:"#0f8238b8",
          text:"Hubo un error, vuelve a intentarlo, Si el error persiste contacte al administrador.",
          type:"error",
          heightAuto:false
      });
    })
  }
}

export function requestSensitiveRegionsInitiatives(data, cbFunction) {
  return (dispatch) => {
    axios.post(`${apiUrl}/initiative/search/`, data).then(result => {
      if(result.status === 200){
        if(result.data.ok === true){
          cbFunction(result.data.initiative);
        }
      }
    }).catch(error => {
      console.log(error);
      Swal.fire({
          title:"Error",
          confirmButtonColor:"#0f8238b8",
          text:"Hubo un error, vuelve a intentarlo, Si el error persiste contacte al administrador.",
          type:"error",
          heightAuto:false
      });
    })
  }
}

export function requestInitiativeVotesComments(data, cbFunction) {
  return (dispatch) => {
    dispatch(queryIsLoading());
   console.log(data);
    axios.post(`${apiUrl}/voting/countForInitiative/`, 
    data,{
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
      }}
            ).then(result => {
      if(result.status === 200){
        let init = {
          ...result.data,
          comments:[...result.data.comments]
        }
        cbFunction(init);
      }
      dispatch(queryNotLoading());
    }).catch(error => {
      console.log(error);
      Swal.fire({
          title:"Error",
          confirmButtonColor:"#0f8238b8",
          text:"Hubo un error, vuelve a intentarlo, Si el error persiste contacte al administrador.",
          type:"error",
          heightAuto:false
      });
      dispatch(queryNotLoading());
    })
  }
}

export function generateVisit() {
  return (dispatch) => {
    dispatch(setShowPurpose(false));
    axios.post(`${apiUrl}/visit/generateVisit/`).then(result => {
      if(result.status === 200){
        console.log(result.status);
      }
    }).catch(error => {
      console.log(error);
    })
  }
}

export function requestVisit(cbFunction) {
  return (dispatch) => {
    axios.get(`${apiUrl}/visit/count/`).then(result => {
      if(result.status === 200){
        if(result.data.ok === true){
          cbFunction(result.data);
        }
      }
    }).catch(error => {
      console.log(error);
    })
  }
}

export const setPathRq = data => ({
  type: INITIATIVE_SET_PATH_REQUEST,
  payload: data
})

export const setShowPurpose = data => ({
  type: INITIATIVE_SET_SHOW_PURPOSE,
  payload: data
})

export const setInitiativeClicked = data => ({
  type: INITIATIVE_SET_INITIATIVE_CLICKED,
  payload: data
})